module.exports = __webpack_public_path__ + "static/img/img-presenter-women.725e473.png";